import { config } from "@/config";

export interface AuthResponse {
  token: string;
  user: { id: string; display_name: string };
}

export async function register(
  email: string,
  password: string,
  displayName: string,
): Promise<AuthResponse> {
  const res = await fetch(`${config.apiUrl}/api/v1/auth/register`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password, display_name: displayName }),
  });

  const body = await res.json();
  if (!res.ok) throw new AuthError(res.status, body.error);
  return body;
}

export async function login(email: string, password: string): Promise<AuthResponse> {
  const res = await fetch(`${config.apiUrl}/api/v1/auth/login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });

  const body = await res.json();
  if (!res.ok) throw new AuthError(res.status, body.error);
  return body;
}

export class AuthError extends Error {
  constructor(
    public status: number,
    public detail: { code: string; message?: string; details?: Record<string, string[]> },
  ) {
    super(detail.message ?? detail.code);
    this.name = "AuthError";
  }
}
